<template>
  <v-dialog v-model="dialog" width="90%" scrollable persistent>
    <v-card>
      <v-card-title class="pa-1">
        <v-col cols="12" class="pa-0 text-right">
          <v-btn icon color="primary" @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12" class="pa-0 text-center">
          <h1>Anexar arquivos nos Recursos</h1>
          <p>Gerencie aqui os anexos dos Recursos de Glosa</p>
        </v-col>
        <v-row class="mx-4 my-2 pa-3" style="background-color: #d1dcea">
          <v-col cols="2" class="pa-0 ma-0">
            <div class="px-0 pt-0 text-list">
              <b>{{ dadosPagamento.oper_nome }}</b
              ><br />
              {{ dadosPagamento.prest_nome }}
            </div>
          </v-col>
          <v-col cols="10" class="pa-0">
            <v-row class="ma-0">
              <v-col class="text-list text-right px-0 py-0"
                ><small>Data pagamento:</small><br /><b>{{
                  dadosPagamento.data_pagamento | formatDate
                }}</b></v-col
              >
              <v-col class="text-list text-right px-0 py-0"
                ><small>Vl.informado(R$):</small><br /><b>{{
                  dadosPagamento.valor_informado | formatPrice
                }}</b></v-col
              >
              <v-col class="text-list text-right px-0 py-0"
                ><small>Vl.liberado(R$):</small><br /><b
                  ><span style="color: #32b88b">{{
                    dadosPagamento.valor_liberado | formatPrice
                  }}</span></b
                ></v-col
              >
              <v-col class="text-list text-right px-0 py-0"
                ><small>Vl.glosado(R$):</small><br /><b
                  ><span style="color: red">{{
                    dadosPagamento.valor_glosado | formatPrice
                  }}</span></b
                >
              </v-col>
              <v-col class="text-list text-right px-0 py-0"
                ><small>Glosa mantida(R$):</small><br /><span
                  style="color: red"
                  >{{ dadosPagamento.valor_glosa_mantida | formatPrice }}</span
                ></v-col
              >
              <v-col class="text-list text-right px-0 py-0"
                ><small>Vl.recursado(R$):</small><br /><span
                  style="color: #32b88b"
                  >{{ dadosPagamento.valor_recursado | formatPrice }}</span
                ></v-col
              >
              <v-col class="text-list text-right px-0 py-0"
                ><small>Vl.acatado(R$):</small><br /><span
                  style="color: #118aca"
                  >{{ dadosPagamento.valor_acatado | formatPrice }}</span
                ></v-col
              >
            </v-row>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="py-2 px-8">
        <AnexosViewFilter
                :filterList="(tab, page, formData) => filterList(tab, page, formData)"
                :filterData="filterAnexosData"
                :motivosGlosaList="motivosGlosaList"
                :prestadoresList="identificadorPrestadoresList"
                :procedimentosList="procedimentosList"
                :estadoList="estadoList[tipo_consulta]"
                :listaNumGuias="listaNumGuias"
                :tipo_pagamento="filterAnexosData.tipo_pagamento"
                :dadosPagamento="dadosPagamento"
                :tab="tab"
                :resetFilter="resetFilter"
              />
        <v-tabs v-model="tab" dense class="elevation-0 px-0"> 
          <v-tab v-show="false" @click="filterList(0, 1)">Lotes</v-tab> 
          <v-tab @click="resetFilter = true, filterList(1, 1)">Guias</v-tab>
          <v-tab v-show="verificaEnvio(undefined, true)" @click="resetFilter = true, guiaSelecionada = null, filterList(2, 1)">Itens</v-tab>  
          <v-tabs-items v-model="tab" class="px-3"> 
            <v-tab-item> 
              <v-row>
                <!--LOTES-->
                <v-col cols="12" class="py-5 px-0">
                  <v-form ref="addProtocoloLotesRecursadosForm">
                    <v-data-table
                      class="lotesRecursoTable"
                      dense
                      :headers="headers"
                      :items="list"
                      hide-default-footer
                    >
                    <template v-slot:item.valor_informado="{ item }">
                  
                        <b v-if="item.valor_informado">{{
                          item.valor_informado | formatPrice
                          
                        }}</b>
                        
                      </template>
                      <template v-slot:item.valor_recursado="{ item }">
                        
                        <b style="color: #32b88b" v-if="item.valor_recursado">{{
                          item.valor_recursado | formatPrice
                          
                        }}</b>
                      </template>
                      <template v-slot:item.data_atualizacao="{ item }">
                        {{ item.data_atualizacao | formatDate }}
                      </template>
                      <template v-slot:item.status="{ item }">
                        <b>{{ item.status }}</b>
                        <v-tooltip bottom open-delay="100" v-if="!!item.erros">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              class="mr-3 mt-2"
                              color="error"
                              small
                              v-bind="attrs"
                              v-on="on"
                              >fa-warning
                            </v-icon>
                          </template>
                          <span
                            class="px-3 py-1 ma-0"
                            style="
                              border: solid 1px #999;
                              border-radius: 5px;
                              background-color: #fff;
                            "
                            >{{ item.erros }}</span
                          >
                        </v-tooltip>
                      </template>
                      <template v-slot:item.anexo="{ item }">
                        <v-tooltip bottom open-delay="20">
                          <template v-slot:activator="{ on, attrs }">
                            <v-badge 
                                  overlap
                                  class="mr-3" 
                                  style="font-weight: bold"
                                  color="accent"
                                  :content="item.qtde_anexos"
                                >
                            <v-icon
                              color="primary"
                              small
                              v-bind="attrs"
                              v-on="on"
                              @click="openUpload(item)"
                              >fa-paperclip
                            </v-icon>
                            </v-badge>
                          </template>
                          <span
                            class="px-3 py-1 ma-0"
                            style="
                              border: solid 1px #999;
                              border-radius: 5px;
                              background-color: #fff;
                            "
                            >Gestão de anexos</span
                          >
                        </v-tooltip>
                      </template>
                    </v-data-table>
                  </v-form>
                </v-col>
                <v-col cols="12" class="py-1 pb-5">
                  <v-pagination
                    class="no-box-shadow"
                    v-model="pagination.current_page"
                    :length="pagination.total_pages"
                    @input="
                      pagination.offset = pagination.current_page;
                      filterList(tab, pagination.current_page);
                    "
                  ></v-pagination>
                </v-col>
              </v-row> 
            </v-tab-item> 
            <v-tab-item> 
              <v-row>
                <!--GUIAS-->
                <v-col cols="12" class="py-5 px-0">
                  <v-form ref="addAnexosForm">
                    <v-data-table
                      class="lotesRecursoTable"
                      dense
                      :headers="headersGuia"
                      :items="list"
                      hide-default-footer
                    >
                      <template v-slot:item.data_autorizacao="{ item }">
                        {{ item.data_autorizacao | formatDate }}
                      </template>
                      <template v-slot:item.valor_recursado="{ item }">
                        <b style="color: #32b88b" v-if="item.valor_recursado">{{
                          item.valor_recursado | formatPrice
                        }}</b>
                      </template>
                      <template v-slot:item.anexo="{ item }">

                        <v-tooltip bottom open-delay="20" v-if="verificaEnvio(item) == 'guia'">
                          <template v-slot:activator="{ on, attrs }">
                            <v-badge 
                                  overlap
                                  class="mr-3" 
                                  style="font-weight: bold"
                                  :color="(item.qtde_anexos > 0?'accent': '#FFFFFF00')"
                                  :content="item.qtde_anexos"
                                >
                            <v-icon
                              color="primary"
                              small
                              v-bind="attrs"
                              v-on="on"
                              @click="openUpload(item)"
                              >fa-paperclip
                            </v-icon>
                            </v-badge>
                            <!-- @click="download({doc_id: item.doc_id_protocolo})" -->
                          </template>
                          <span
                            class="px-3 py-1 ma-0"
                            style="
                              border: solid 1px #999;
                              border-radius: 5px;
                              background-color: #fff;
                            "
                            >Gestão de anexos</span
                          >
                        </v-tooltip>

                        <v-tooltip bottom open-delay="20" v-else>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              color="primary"
                              small
                              v-bind="attrs"
                              v-on="on"
                              @click="abreItens(item)"
                              >fa-eye
                            </v-icon>
                            <!-- @click="download({doc_id: item.doc_id_protocolo})" -->
                          </template>
                          <span
                            class="px-3 py-1 ma-0"
                            style="
                              border: solid 1px #999;
                              border-radius: 5px;
                              background-color: #fff;
                            "
                            >Itens</span
                          >
                        </v-tooltip>

                      </template>
                    </v-data-table>
                  </v-form>
                </v-col>
                <v-col cols="12" class="py-1 pb-5">
                  <v-pagination
                    class="no-box-shadow"
                    v-model="pagination.current_page"
                    :length="pagination.total_pages"
                    @input="
                      pagination.offset = pagination.current_page;
                      filterList(tab, pagination.current_page, filterAnexosData);
                    "
                  ></v-pagination>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item>
              
              <!-- <v-row>
                <v-col class="px-1 py-1" cols="3" v-show="tab == 2">
                  <label>Nº guia prestador </label> 
                  <v-autocomplete
                    v-model="guiaSelecionada"
                    :items="listaNumGuias"
                    placeholder="Selecione"
                    item-value="id"
                    item-text="descricao"
                    :menu-props="{ bottom: true, offsetY: true }"
                    flat
                    solo
                    dense
                    outlined
                  ></v-autocomplete>
                </v-col>
                <v-col class="px-2 pt-5 align-right">
                  <v-btn
                    style="margin-right: 16px !important"
                    small
                    height="32px"
                    color="primary"
                    class="px-2 mr-2"
                    depressed
                    @click="filterList(2, 1, guiaSelecionada.id)"
                    >Filtrar</v-btn
                  >
                  <v-btn
                    outlined
                    small
                    height="32px"
                    color="primary"
                    class="px-2 ml-0"
                    depressed
                    @click="filterList(2, 1), guiaSelecionada = null"
                    >Limpar Filtro</v-btn
                  >
                </v-col>
              </v-row> -->
              <v-row>
                <!--ITENS-->

                <v-col cols="12" class="pt-5 px-0">
                  <v-form ref="addAnexosForm">
                    <v-data-table
                      class="lotesRecursoTable"
                      dense
                      :headers="headersItens"
                      :items="list"
                      hide-default-footer

                    >
                      <template v-slot:item.data_execucao="{ item }">
                        {{ item.data_execucao | formatDate }}
                      </template>
                      <template v-slot:item.anexo="{ item }">
                        <v-tooltip bottom open-delay="20" >
                          <template v-slot:activator="{ on, attrs }">
                             <v-badge                                  
                                  style="font-weight: bold"
                                  :color="(item.qtde_anexos > 0?'accent': '#FFFFFF00')"
                                  :content="item.qtde_anexos"
                                >
                            <v-icon
                              color="primary"
                              small
                              v-bind="attrs"
                              v-on="on"
                              @click="openUpload(item)"
                              >fa-paperclip
                            </v-icon>
                             </v-badge>
                          </template>
                          <span
                            class="px-3 py-1 ma-0"
                            style="
                              border: solid 1px #999;
                              border-radius: 5px;
                              background-color: #fff;
                            "
                            >Gestão de anexos</span
                          >
                        </v-tooltip>
                      </template>

                      <template v-slot:item.valor_recursado="{ item }">
                  
                        <b style="color: #32b88b" v-if="item.valor_recursado">{{
                          item.valor_recursado | formatPrice
                        }}</b>
                      </template>

                      <template v-slot:item.valor_unitario="{ item }">
                        
                        <b style="color: #32b88b" v-if="item.valor_unitario">{{
                          item.valor_unitario | formatPrice
                          
                        }}</b>
                      </template>
                    </v-data-table>
                  </v-form>
                </v-col>
                <v-col cols="12" class="py-1">
                  <v-pagination
                    class="no-box-shadow"
                    v-model="pagination.current_page"
                    :length="pagination.total_pages"
                    @input="
                      pagination.offset = pagination.current_page;
                      filterList(tab, pagination.current_page, filterAnexosData);
                    "
                  ></v-pagination>
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs> 
      </v-card-text>

      <v-card-actions class="justify-center py-5" v-show="false">
        <v-btn
          color="primary"
          outlined
          height="30px"
          small
          depressed
          @click="close()"
          >Fechar
        </v-btn>
      </v-card-actions>
    </v-card>
    <AnexosUploadDlg
      :close="() => (showUploadDlg = false)"
      :dadosPagamento="dadosPagamento"
      :dialog="showUploadDlg"
      :emMassa="false"
      :filterData="{}"
      :grupoEconomico="grupoEconomico"
      :itemSelecionado="itemSelecionado"
      :tipoConsulta="tipo_consulta"
      :listaArquivos="listaArquivos"
      :getArquivosAnexo="getArquivosAnexo"
      :parametros="parametros"
      :num_lote="numero_lote"
      :total="0"
    />
  </v-dialog>
</template>

<script>
import AnexosUploadDlg from "./AnexosUploadDlg";
import AnexosViewFilter from "./AnexosViewFilter.vue";
export default {
  components: {
    AnexosUploadDlg,
    AnexosViewFilter
  },
  data() {
    return {
      selecao:{},
      filterAnexosData: {},
      headers: [
        {
          text: "Ident. prestador",
          value: "identificador_prestador",
          sortable: false,
        },
        {
          text: "Protocolo recursado",
          value: "protocolo_recursado",
          sortable: false,
        },
        { text: "Nº do Lote", value: "numero_lote", sortable: false },
        {
          text: "N da Guia do Recurso",
          value: "numero_guia_recurso",
          sortable: false,
        },
        { text: "Vl. Recursado", value: "valor_recursado", sortable: false },
        {
          text: "Data atualização",
          value: "data_atualizacao",
          sortable: false,
        },
        { text: "Anexos", value: "anexo", align: "center", sortable: false },
      ],
      headersGuia: [
        { text: "Protocolo recursado", value: "protocolo_recursado", sortable: false },
        { text: "Nº do Lote", value: "numero_lote", sortable: false },
        { text: "Nº guia prestador", value: "numero_guia_prestador", sortable: false },
        { text: "Beneficiário", value: "nome_beneficiario", sortable: false },
        {
          text: "Carteirinha",
          value: "carteira_beneficiario",
          sortable: false,
        },
        { text: "Senha", value: "senha", sortable: false },
        {
          text: "Valor recursado (R$)",
          align: "end",
          value: "valor_recursado",
          sortable: false,
        },
        { text: "Anexos", value: "anexo", align: "center", sortable: false }, // tem_anexo
      ],
      headersItens: [
        {
          text: "Nº guia prestador",
          value: "numero_guia_prestador",
          sortable: false,
        },
        {
          text: "Data da execução",
          align: "center",
          value: "data_execucao",
          sortable: false,
        },
        {
          text: "Ident. prestador",
          value: "identificador_prestador_captura",
          sortable: false,
        },
        { text: "Beneficiário", value: "nome_beneficiario", sortable: false },
        {
          text: "Carteirinha",
          value: "carteira_beneficiario",
          sortable: false,
        },
        {
          text: "Procedimento/Despesa",
          value: "descricao_procedimento",
          sortable: false,
        },
        { text: "Qtde", align: "center", value: "quantidade", sortable: false },
        {
          text: "Valor unitario (R$)",
          align: "right",
          value: "valor_unitario",
          sortable: false,
        },
        {
          text: "Valor recursado (R$)",
          align: "right",
          value: "valor_recursado",
          sortable: false,
        },
        // {
        //   text: "Valor acatado (R$)",
        //   align: "right",
        //   value: "valor_acatado",
        //   sortable: false,
        // },
        // { text: "Motivo Glosa", value: "motivos_glosa", align: "left", sortable: false },
        // { text: "Motivo recurso", value: "motivo_glosa_digitado", align: "left", sortable: false },
        // { text: "Justificativa", value: "justificativa", align: "left", sortable: false },
        { text: "Anexos", value: "anexo", align: "center", sortable: false },
        // { text: "Área geradora", value: "area_geradora", align: "left", sortable: false },
        // { text: "Direcionamento", value: "direcionamento", align: "left", sortable: false },
        // { text: "Ações", class:"acao", sortable: false, value: "data-table-update" },
      ],
      itemSelecionado: {},
      list: [
        // { //usada para testes
        //   valor_recursado:42.0,
        //   numero_guia_prestador:12345,
        //   valor_informado:83.5,
        //   carteira_beneficiario:7234,
        //   identificador_prestador_captura:242,
        //   data_autorizacao: "31/02/02",
        //   nome_beneficiario:"Jeremias da silva pereira",
        //   senha:"senha",
        //   id: "7"

        // }
      ],
      estadoList: {
        itens: [
          {
            id: 1,
            descricao: "Guia analisada",
            cor: "primary",
          },
          {
            id: 2,
            descricao: "Item analisado",
            cor: "#cfd403",
          },
          {
            id: 4,
            descricao: "Aguardando Análise",
            cor: "#979797",
          },
        ],
        guias: [
          {
            id: 1,
            descricao: "Guia analisada",
            cor: "primary",
          },
          {
            id: 2,
            descricao: "Todos os itens analisados",
            cor: "#cfd403",
          },
          {
            id: 3,
            descricao: "Alguns itens analisados",
            cor: "#FC9D0A",
          },
          {
            id: 4,
            descricao: "Aguardando Análise",
            cor: "#979797",
          },
        ],
      },
      dataSave: null,
      motivosGlosaList:[],
      identificadorPrestadoresList:[],
      procedimentosList:[],
      pagination: {
        current_page: 1,
        limit: 5,
        offset: 1,
        total_pages: 1,
      },
      showUploadDlg: false,
      tab: 1, //depois que tiver lotes e itens mudar para 0
      tipo_consulta: "guias", //depois que tiver lotes e itens mudar para "lotes"
      acoesList: [
        { tipo: "lotes", acao: "getlotesrecursados" },
        { tipo: "guias", acao: "getguiasrecursoglosa" },
        { tipo: "itens", acao: "getitensrecursoglosa" },
      ],
      listaArquivos: [],
      listaNumGuias : [{id: null, descricao:"Selecione"}],
      guiaSelecionada: null,
      numero_lote: null,
      temGuia: [],
      temItem: [],
      resetFilter: false
    };
  },
  watch: {
    dialog(val) {
      if (val) {
        this.popularListasSelecao();
        this.filterList(this.tab, 1);
      } else {
        this.tab = 1; //depois que tiver lotes e itens mudar para 0
        this.pagination.current_page = 1;
        this.pagination.total_pages = 1;
        this.list = []; //descomentar para funcionar normalmente
      }
    },
    tab(val){
      this.tipo_consulta = val == 1 ? "guias" : "itens"
    }
  },
  props: {
    close: Function,
    dialog: Boolean,
    //downloadRecurso: Function,
    getList: Function,
    grupoEconomico: Number,
    dadosPagamento: Object,
    parametros: Object
  },
  methods: {
    confirmLiberarParaEnvio() {
      let paramModal = {
        type: "info",
        title: "Liberar para envio o recurso de glosa",
        message:`Após a liberação não será possível anexar mais arquivos e<br>o recurso será enviado à operadora.<br>Deseja liberar o envio do recurso?`,
        callback: () => this.liberarParaEnvio(this.dadosPagamento),
        btConfirm: { name: 'Liberar envio', show: true, color: "primary" },
        btCancel:{ name: "Cancelar", show: true },
      };
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    },
    liberarParaEnvio(pagamento){
      console.log(pagamento)
    },
    popularListasSelecao(){
      let payload = { grupo_economico: this.grupoEconomico };
      payload.pagamento_id = this.dadosPagamento.id;
      let obj = {
        query: [
          {
            modulo: "Recebiveis",
            acao: "getrecursoglosaedicao",
            payload: payload,
          },
        ]
      }; //returnError: true
       this.$store
        .dispatch("request/doRequest", obj, { root: true })
        .then((response) => {
          if (!response || response.isAxiosError || response.erros.length) {
            this.$store.commit("hideLoader");
            return;
          }

          this.procedimentosList = response.codigo_procedimento;
          this.identificadorPrestadoresList = response.identificador_prestador;
          return obj;
        })
        .then(() => {
          payload.pagamento_id = this.dadosPagamento.id;

          let opts = {
            query: [
              {
                modulo: "Recebiveis",
                acao: "getmotivosglosa",
                payload: payload,
              },
            ]
          };
          this.$store
            .dispatch("request/doRequest", opts, { root: true })
            .then((response) => {
              if (!response || response.isAxiosError || (response.erros && response.erros.length)) {
                this.$store.commit("hideLoader");
                return;
              }
              this.motivosGlosaList = response.dados;
            });
        });
    },
    filterList(newTab, page, formData) {
      this.pagination.offset = page ? page : 1;
      this.tipo_consulta = this.acoesList[newTab].tipo;
      let acao = this.acoesList[newTab].acao;
      let pagamento_id = this.dadosPagamento.id;
      let payload = Object.assign({
        grupo_economico: this.grupoEconomico,
        pagamento_id,
        ...this.pagination,
        recursadas: true,
        ...formData
      });
      payload[this.paramId] = this.pagamentoId;
      let obj = {
        query: [{ modulo: "Recebiveis", acao: acao, payload: payload }]
      };
      
      this.$store
        .dispatch("request/doRequest", obj, { root: true })
        .then((response) => {
          if (!response || response.isAxiosError || response.erros.length) {
            this.$store.commit("hideLoader");
            return;
          }
          this.resetFilter = false;
          this.filterAnexosData = {...formData};
          this.list = response.dados; //descomentar 
          this.pagination.current_page = response.current_page;
          this.pagination.offset = response.current_page;
          this.pagination.total_pages = response.total_pages;
          // if(acao =="getguiasrecursoglosa"){
          //   this.listaNumGuias = response.listaNumGuias;
          //   this.listaNumGuias.unshift({id: null, descricao:"Selecione"});          
          // }
        })
    },
    openUpload(item) {
      this.showUploadDlg = true;
      this.itemSelecionado = item;
      this.getArquivosAnexo(item)
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("T")[0].split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },
    getArquivosAnexo(item){
      let payload = { 
        grupo_economico: this.grupoEconomico, 
        prestador_id: this.dadosPagamento.prestador_id,
        recurso_stage_id: item.recurso_stage_id,
        recurso_lote_id: item.recurso_lote_id,
        offset: 1,
        limit: 20
      };
      if(this.tipo_consulta == 'guias'){
        payload.recurso_guia_id = item.id;

      } else if(this.tipo_consulta == 'itens'){
        payload.recurso_item_id = item.id;
      }

      let obj = {query: [{ Modulo: "Recebiveis", Acao: "getanexorecurso", Payload: payload}]}
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader");
          return;
        }
        
        let listaCorrigida = [];
        
        response.dados.forEach((dado, indice)=> {
          listaCorrigida[indice] = {
            doc_id: dado.doc_id,
            dt_upload: dado.data_upload,
            id: dado.id,
            nome: dado.arq_nome,
            username_upload: dado.username_upload,
            tipo_anexo: dado.tipo_anexo
          }
          this.listaArquivos = listaCorrigida
          
          
        });

        if(listaCorrigida.length == 0){
          this.listaArquivos = []
        }
        this.totalArquivos = this.listaArquivos.length

      })  
    },
    verificaEnvio(item, aba=false){
      
      if(this.parametros.RG_ANEXO_PARAM == null){
        return 'guia'
      }

      let niveis = JSON.parse(this.parametros.RG_ANEXO_PARAM)
      niveis = niveis && niveis.niveis? JSON.parse(niveis.niveis) : [];
      this.temGuia = niveis.includes('guia')
      this.temItem = niveis.includes('item')

      if(aba && this.temItem){
        return true
      }

      if(aba && !this.temItem){
        return false
      }


      if(this.temGuia && !this.temItem){
        return 'guia'
      }
      if(!this.temGuia && this.temItem){
        return 'item'
      }
      if(this.temGuia && this.temItem){
        if(item.flag_recurso_guia){
          return 'guia'
        }
        else{
          return 'item'
        }
      }
      if(!this.temGuia && !this.temItem){
        return 'guia'
      }
      
    },
    abreItens(item){
      this.tab=2
      this.filterAnexosData.numero_guia = item.numero_guia_operadora
      this.filterList(this.tab, 1, this.filterAnexosData)
      //this.guiaSelecionada = {id:item.id, descricao:item.numero_guia_operadora}
      //this.numero_lote = item.numero_lote != '' ? item.numero_lote : item.numero_lote_demonstrado

    }
  },
};
</script>

<style lang="scss">
.text-list {
  font-size: 13px;
  line-height: 1.15em;
}
.text-list.space {
  margin-right: 3px;
}
.text-list.pres {
  width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.lotesRecursoTable.envio_manual {
  .v-data-table__wrapper > table > tbody > tr td:nth-child(5),
  .v-data-table__wrapper > table > tbody > tr td:nth-child(6) {
    background-color: rgba(207, 212, 3, 0.1) !important;
  }
}
.lotesRecursoTable {
  .v-data-table__wrapper > table > tbody > tr td:nth-child(6) {
    max-width: 150px;
  }
}
</style>